import { listLaborByDJTIds } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const fetchLaborByDJTId = async (djtId) => {
  if (!djtId) return;

  try {
    const response = await client.graphql({
      query: listLaborByDJTIds,
      variables: { djtId: djtId },
    });

    const results = response.data.laborByDJTId.items;
    
    return results;
  } catch (err) {
    return ('error fetchLaborByDJTId: ', [err]);
  }
};

fetchLaborByDJTId.propTypes = {
  djtId: PropTypes.string.isRequired,
};
